import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LeaderLinesComponent } from './leader-lines.component';

@NgModule({
  declarations: [LeaderLinesComponent],
  imports: [CommonModule],
  exports: [LeaderLinesComponent],
})
export class LeaderLinesModule {}
